<template>
    <ul class="gallery">
        <template v-if="imgs.length == 0">
            <li>
                <div data-gallery="item_gallery">
                    <div style="background-image: url('/i/nophoto.png')" :title="this.title"></div>
                </div>
            </li>
            <li>
                <div data-gallery="item_gallery">
                    <div style="background-image: url('/i/nophoto.png')" :title="this.title"></div>
                </div>
            </li>
        </template>
        <template v-else v-for="(src, index) in imgs">
            <li v-if="index < 4 || showAll">
                <div data-gallery="item_gallery" @click="showMultiple(index)">
                    <div :style="'background-image: url(' + src + ')'" :title="this.title"></div>
                </div>
            </li>
        </template>
    </ul>
    <div v-if="imgs.length > 4 && !showAll" class="list-more">
        <button type="button" class="btn btn-outline-regular btn-bi w-100"
            @click="showAllToggle"><ins>Показать еще</ins></button>
    </div>
    <div>
        <!-- all props & events -->
        <vue-easy-lightbox
            escDisabled
            moveDisabled
            :visible="visible"
            :imgs="imgs"
            :index="index"
            @hide="handleHide"
        ></vue-easy-lightbox>
    </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
    components: {
        VueEasyLightbox
    },
    props: ['images', 'title'],
    data() {
        return {
            imgs: this.images,
            visible: false,
            index: 0, // default: 0
            showAll: false,
        }
    },
    methods: {
        showSingle(index = 0) {
            this.index = index // index of imgList
            this.show()
        },
        showMultiple(index = 0) {
            this.index = index // index of imgList
            this.show()
        },
        show() {
            this.visible = true
        },
        handleHide() {
            this.visible = false
        },
        showAllToggle() {
            this.showAll = !this.showAll;
        }
    }
}
</script>
<script setup lang="ts">
</script>
